/// <amd-module name="Artifacts/Root/types/IPackageVersion" />
import { IMinimalPackageVersion } from "Artifacts/Root/types/IMinimalPackageVersion";
import {
  PackageDependency,
  PackageFile,
  ProtocolMetadata,
  UpstreamSource,
} from "Artifacts/Root/web-apis/contracts/Feed";
/**
 * A specific version of a package.
 */
// TODO: revisit dependency on web-api contracts
export interface IPackageVersion extends IMinimalPackageVersion {
  /**
   * Package version author.
   */
  author: string;
  /**
   * UTC date that this package version was deleted.
   */
  deletedDate?: Date;
  /**
   * List of dependencies for this package version.
   */
  dependencies: PackageDependency[];
  /**
   * Package version description.
   */
  description: string;
  /**
   * Normalized version using normalization rules specific to a package type.
   */
  normalizedVersion: string;
  /**
   * List of upstream sources through which a package version moved to land in this feed.
   */
  sourceChain: UpstreamSource[];
  /**
   * Package version url.
   */
  url: string;
  /**
   * Extended data specific to a package type.
   */
  protocolMetadata: ProtocolMetadata;
  /**
   * Package version tags.
   */
  tags: string[];
  /**
   * Files associated with this package version, only relevant for multi-file package types.
   */
  files: PackageFile[];
  /**
   * (NuGet and Cargo Only) True if this package is listed.
   */
  isListed?: boolean;

  /**
   * Flag to determine whether the package version is deleted
   */
  isDeleted: boolean;
}
